/** Full-page skeleton while candidate record loads (Phase 7 §2.4 — no spinner). */
export function CandidateDetailPageSkeleton() {
  return (
    <div className="w-full min-w-0 mx-auto max-w-none space-y-6 animate-pulse" aria-busy="true">
      <div className="h-10 w-2/3 max-w-md rounded bg-[var(--vscode-bg-secondary)] border border-[var(--vscode-border-primary)]" />
      <div className="grid grid-cols-1 xl:grid-cols-12 gap-6">
        <div className="xl:col-span-3 space-y-4">
          <div className="h-24 rounded-lg bg-[var(--vscode-bg-secondary)] border border-[var(--vscode-border-primary)]" />
          <div className="h-40 rounded-lg bg-[var(--vscode-bg-secondary)] border border-[var(--vscode-border-primary)]" />
          <div className="h-16 rounded-lg bg-[var(--vscode-bg-secondary)] border border-[var(--vscode-border-primary)]" />
        </div>
        <div className="xl:col-span-5 space-y-4">
          {[1, 2, 3, 4].map((i) => (
            <div key={i} className="h-16 rounded-lg bg-[var(--vscode-bg-secondary)] border border-[var(--vscode-border-primary)]" />
          ))}
        </div>
        <div className="xl:col-span-4 space-y-4">
          <div className="h-10 rounded bg-[var(--vscode-bg-secondary)] border border-[var(--vscode-border-primary)]" />
          <div className="h-64 rounded-lg bg-[var(--vscode-bg-secondary)] border border-[var(--vscode-border-primary)]" />
        </div>
      </div>
    </div>
  );
}
